import React from 'react'
import styled from 'styled-components'
import { Link } from '@src/quince-components/src'
import { desktopVw } from '../styles/utils'
import { getPathName } from '../utils'
import richTextRenderer from '../utils/richTextRenderer'
import { MARKS, INLINES } from '@contentful/rich-text-types'

import { phoneNumberPattern } from '../utils'

const StyleWrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 19px;
    font-family: ${props => props.theme.fonts.primary};
    font-size: 15px;
    font-weight: 400;
  }

  b {
    font-weight: 500;
  }

  ul {
    list-style-type: disc;
  }

  ul,
  ol {
    margin-top: 0;
    font-size: 15px;
    padding-left: 1.1em;
    margin-bottom: 21px;

    li {
      margin: 0;

      p {
        margin: 0;
      }
    }
  }

  p {
    font-size: 12px;
    line-height: 19px;
    margin-bottom: 21px;

    &:last-child:empty {
      display: none;
    }
  }

  a {
    text-decoration: underline;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-bottom: ${desktopVw(20)};
      font-size: ${desktopVw(15)};
    }

    p {
      font-size: ${desktopVw(12)};
      line-height: ${desktopVw(20)};
      margin-bottom: ${desktopVw(30)};
    }

    ul,
    ol {
      font-size: ${desktopVw(15)};
      margin-bottom: ${desktopVw(20)};

      li {
        margin: 0;

        p {
          margin: 0;
        }
      }
    }
  }
`

const InlineLink = styled(Link)`
  text-decoration: underline;
`

const WarningText = styled.div`
  b {
    color: ${props => props.theme.colors.maroon} !important;
    font-weight: normal !important;
  }
`

const renderHyperLinkNode = ({ content, data }) => {
  if (phoneNumberPattern.test(data.uri)) {
    return <a href={`tel:${data.uri}`}>{content[0].value}</a>
  }

  if (data.uri.includes('@')) {
    return <a href={`mailto:${data.uri}`}>{content[0].value}</a>
  }

  return <a href={data.uri}>{content[0].value}</a>
}

const options = {
  renderNode: {
    [INLINES.HYPERLINK]: node => renderHyperLinkNode(node),
    [INLINES.ENTRY_HYPERLINK]: ({ content, data }) => {
      return <InlineLink to={getPathName(data.target.fields.slug['en-US'])}>{content[0].value}</InlineLink>
    },
  },
  renderMark: {
    [MARKS.BOLD && MARKS.CODE]: text => <WarningText>{text}</WarningText>,
  },
}

const RichText = ({ className, json }) => {
  const content = typeof json === 'string' ? JSON.parse(json) : json
  return (
    <StyleWrapper className={`${className ? className : ''} rich-text`}>
      {richTextRenderer(content, options)}
    </StyleWrapper>
  )
}

export default RichText
